<template>
    <top-users :users="weeklyLeaderboardUsers" :style="{ height: weeklyLeaderboardUsers.length === 1 ? '150px' : '' }" />
    <users-list :users="weeklyLeaderboardUsers" />
</template>



<script setup>

import { computed } from 'vue';
import { LeaderboardStore } from "@/store/LeaderboardStore";
import TopUsers from "@/components/Leaderboard/Top-Users.vue";
import UsersList from "@/components/Leaderboard/Users-List.vue";

const leaderboardStore = LeaderboardStore();

const weeklyLeaderboardUsers = computed(() => {
    return leaderboardStore.last7DaysLeaderboard;
});

</script>
